import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Divider } from '../../divider/Divider.mjs';
import { divider } from '../datePicker.vanilla.mjs';

const DatePickerDivider = ({ className, ...props }) => /* @__PURE__ */ jsx(
  Divider,
  {
    color: "black006",
    className: classNames(divider, className),
    ...props
  }
);

export { DatePickerDivider as default };
//# sourceMappingURL=Divider.mjs.map
